export const DADOS_CADASTRAIS = 'Dados cadastrais do devedor';
export const CATEGORIA = 'Categoria';
export const CPF_CPNJ = 'CPF/CNPJ';
export const CODIGO_CLIENTE = 'Código no Cliente';
export const CODIGO_DEVEDOR = 'Código do Devedor';
export const RAZAO_SOCIAL = 'Razão Social/Nome';
export const PREPOSTO = 'Preposto';
export const NOME_FANTASIA = 'Nome Fantasia';
export const INSCRICAO_ESTADUAL = 'Inscrição Estadual';
